// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{margin:0;padding:0;height:100vh;background:#fff}.main-container{min-height:calc(100vh - 136px);margin-top:55px}.el-pagination{white-space:pre-wrap}.el-message-box{width:320px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
